import Decimal from 'decimal.js-light';
import { walletSettings, allViewCurrency } from '@bz/common';

const currencyConvertHint = (
  amount: Decimal | number | string,
  currencyCode: string,
  targetCurrency: string,
  type: 'display' | 'transaction',
  hasAlias = true
) => {
  // 使用传入的 currencyCode，如果没有则默认使用 walletSettings.showCurrency
  const source = currencyCode ?? walletSettings.showCurrency;
  const targetCode = targetCurrency ?? walletSettings.showCurrency;

  // 优先使用 allViewCurrency，如果没有再使用 currencyConfig，最后使用默认值
  const viewConfig = allViewCurrency[targetCode];
  const currencyTransactionConfig = currencyConfig[targetCode];
  // const config = viewConfig ?? currencyConfig[targetCode];
  const config = type === 'display' ? viewConfig : currencyTransactionConfig;

  const money = currency.printCurrency(amount, source, {
    target: targetCode,
    precision: config?.showUnit ?? 2,
    padZeros: (config?.zeroPlace ?? 0) > 0,
    hasAlias,
  });

  return money;
};
export const currencyConvert = (
  amount: Decimal | number | string,
  currencyCode: string,
  targetCurrency: string,
  type: 'display' | 'transaction',
  hasAlias = true
) => {
  // 使用传入的 currencyCode，如果没有则默认使用 walletSettings.showCurrency
  const source = currencyCode ?? walletSettings.showCurrency;
  const targetCode = targetCurrency ?? walletSettings.showCurrency;

  // 优先使用 allViewCurrency，如果没有再使用 currencyConfig，最后使用默认值
  const viewConfig = allViewCurrency[targetCode];
  const currencyTransactionConfig = currencyConfig[targetCode];
  // const config = viewConfig ?? currencyConfig[targetCode];
  const config = type === 'display' ? viewConfig : currencyTransactionConfig;

  const money = currency.printCurrency(amount, source, {
    target: targetCode,
    precision: config?.showUnit ?? 2,
    padZeros: (config?.zeroPlace ?? 0) > 0,
    hasAlias,
  });

  return money;
};

export default currencyConvertHint;
